import DataTable from '../components/DataTable'
import { KTSVG } from '../../_metronic/helpers'
import 'react-loading-skeleton/dist/skeleton.css'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import { postRequestOptions } from '../helpers/Fetchwrapper'
import GetPagePermission from '../components/GetPagePermission'

function PackingOrderList() {
	const hasPermission = GetPagePermission('/packing-orders')
	const canDelete = GetPagePermission('/delete-packing-orders')

	const handleDelete = async (row: any) => {
		const confirm = await Swal.fire({
			title: 'Are you sure?',
			text: `This will permanently delete packing order ${row.packingOrderNo}: its finished goods stock-in, packing material stock-out and accounting voucher.`,
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#ec008c',
			cancelButtonText: 'Cancel',
			confirmButtonText: 'Yes, Delete',
		})
		if (!confirm.isConfirmed) {
			return
		}

		try {
			const response = await fetch(`${process.env.REACT_APP_API_URL}packing-orders/delete/${row.id}`, postRequestOptions({}))
			const data = await response.json()
			if (data.success) {
				Swal.fire({ icon: 'success', title: 'Success', text: data.successMessage }).then(() => window.location.reload())
			} else {
				Swal.fire({ icon: 'error', title: 'Error', text: data.errorMessage || data.errors || 'Action failed.' })
			}
		} catch (error) {
			Swal.fire({ icon: 'error', title: 'Error', text: 'An error occurred.' })
		}
	}

	const columns = [
		{ value: 'id', title: 'Id', style: { textAlign: 'center' } },
		{ value: 'packingOrderNo', title: 'Packing Order No', style: { textAlign: 'left' } },
		{ value: 'productionOrderNo', title: 'Blending Order No', style: { textAlign: 'left' } },
		{ value: 'batchNo', title: 'Batch No', style: { textAlign: 'left' } },
		{ value: 'projectName', title: 'Project', style: { textAlign: 'left' } },
		{ value: 'productName', title: 'Product', style: { textAlign: 'left' } },
		{ value: 'packingDate', title: 'Packing Date', style: { textAlign: 'left' } },
		{ value: 'createdBy', title: 'Created By', style: { textAlign: 'left' } },
		{
			value: 'action',
			title: 'Action',
			style: { textAlign: 'left', whiteSpace: 'nowrap' },
			hasActionsComponent: true,
			actionsComponent: ((row: any) => {
				return (
					<>
						<Link className="btn btn-light-primary btn-sm me-1" to={`/packing-order-details/${row.id}`}>
							<KTSVG
								path="/media/svg/icons/Layout/Layout-grid.svg"
								className="svg-icon-5 svg-icon"
							/>		Details
						</Link>
						{canDelete === 1 &&
							<button type="button" className="btn btn-light-danger btn-sm me-1" onClick={() => handleDelete(row)}>
								Delete
							</button>
						}
					</>
				)
			}),
		},
	]

	const filters = {
		id: { filterType: 'like', filterValue: '' },
		packingOrderNo: { filterType: 'like', filterValue: '' },
		productionOrderNo: { filterType: 'like', filterValue: '' },
		batchNo: { filterType: 'like', filterValue: '' },
		projectName: { filterType: 'like', filterValue: '' },
		productName: { filterType: 'like', filterValue: '' },
		packingDate: { filterType: 'like', filterValue: '' },
		createdBy: { filterType: 'like', filterValue: '' },
	}

	const url = process.env.REACT_APP_API_URL + 'packing-orders/dt'

	return (
		<>
			{hasPermission === 1 &&
				<div className="card card-custom">
					<div className="card-header">
						<div className="card-title">
							<KTSVG path="/media/svg/icons/Text/Bullet-list.svg" className="svg-icon-1 svg-icon-primary" />
							<span className="text fw-bolder" style={{ marginLeft: '10px' }}>
								Packing Orders
							</span>
						</div>
					</div>

					<div className="card-body">
						<DataTable url={url} columns={columns} filters={filters} />
					</div>
				</div>
			}
		</>
	)
}

export default PackingOrderList
